import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'inc-err-no-data',
  templateUrl: './err-no-data.component.html',
  styleUrls: ['./err-no-data.component.scss'],
})
export class ErrNoDataComponent implements OnInit {
  @Input() subjectName: string;
  @Input() noDesc: boolean;
  @Input() fullText: boolean;

  constructor() { }

  ngOnInit() { }

}
